import Vue from 'vue'
const dataCard = new Vue()
export default dataCard